import Link from 'next/link';
import AppLogo from '@/components/ui/AppLogo';
import CookieSettingsButton from '@/components/CookieSettingsButton';

export default function PublicFooter() {
  return (
    <footer
      style={{
        background: '#060B14',
        borderTop: '1px solid rgba(255,255,255,0.06)',
        paddingTop: '60px',
        paddingBottom: '0',
      }}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-10 pb-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link href="/" className="flex items-center gap-2 mb-4">
              <AppLogo size={32} />
              <span className="font-bold text-white text-lg tracking-tight">Incade</span>
              <span className="text-[#F97316] text-sm font-mono font-semibold">.io</span>
            </Link>
            <p className="text-[13px] text-[#64748B] leading-relaxed mb-5">
              Weekly Cut, Keep, or Scale decisions backed by real revenue data. Stop trusting platform ROAS.
            </p>
            <div className="flex flex-col gap-3">
              <a
                href="https://www.linkedin.com/company/incade-ad-decision-engine"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-[13px] text-[#64748B] hover:text-white transition-colors duration-200"
              >
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                </svg>
                LinkedIn
              </a>
              <a
                href="https://www.facebook.com/incade.ad.decision.engine/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-[13px] text-[#64748B] hover:text-white transition-colors duration-200"
              >
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                </svg>
                Facebook
              </a>
              <a
                href="https://www.youtube.com/@incade-ad-decision-engine"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-[13px] text-[#64748B] hover:text-white transition-colors duration-200"
              >
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
                </svg>
                YouTube
              </a>
              <a
                href="https://www.instagram.com/incade.io/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-[13px] text-[#64748B] hover:text-white transition-colors duration-200"
              >
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
                </svg>
                Instagram
              </a>
            </div>
          </div>

          {/* Product */}
          <div>
            <h3
              style={{ fontSize: '11px', fontWeight: 700, letterSpacing: '0.1em', color: 'white' }}
              className="uppercase mb-5"
            >
              Product
            </h3>
            <ul className="space-y-3">
              {[
                { href: '/features', label: 'Features' },
                { href: '/pricing', label: 'Pricing' },
                { href: '/webinars', label: 'Webinars' },
                { href: '/partners', label: 'Partner Program' },
              ]?.map((item) => (
                <li key={item?.href}>
                  <Link
                    href={item?.href}
                    className="text-[13px] text-[#64748B] hover:text-white transition-colors duration-200"
                  >
                    {item?.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Tools */}
          <div>
            <h3
              style={{ fontSize: '11px', fontWeight: 700, letterSpacing: '0.1em', color: 'white' }}
              className="uppercase mb-5"
            >
              Tools
            </h3>
            <ul className="space-y-3">
              <li>
                <Link
                  href="/ad-waste-estimator"
                  className="text-[13px] text-[#64748B] hover:text-white transition-colors duration-200"
                >
                  Ad Waste Estimator (Free)
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3
              style={{ fontSize: '11px', fontWeight: 700, letterSpacing: '0.1em', color: 'white' }}
              className="uppercase mb-5"
            >
              Company
            </h3>
            <ul className="space-y-3">
              {[
                { href: '/about', label: 'About' },
                { href: '/blog', label: 'Blog' },
                { href: '/careers', label: 'Careers' },
                { href: '/contact', label: 'Contact' },
              ]?.map((item) => (
                <li key={item?.href}>
                  <Link
                    href={item?.href}
                    className="text-[13px] text-[#64748B] hover:text-white transition-colors duration-200"
                  >
                    {item?.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3
              style={{ fontSize: '11px', fontWeight: 700, letterSpacing: '0.1em', color: 'white' }}
              className="uppercase mb-5"
            >
              Legal
            </h3>
            <ul className="space-y-3">
              {[
                { href: '/privacy-policy', label: 'Privacy Policy' },
                { href: '/terms', label: 'Terms of Service' },
                { href: '/billing-policy', label: 'Billing Policy' },
                { href: '/gdpr', label: 'GDPR Compliance' },
                { href: '/cookie-policy', label: 'Cookie Policy' },
                { href: '/impressum', label: 'Impressum' },
                { href: '/delete-my-data', label: 'Delete My Data' },
              ]?.map((item) => (
                <li key={item?.href}>
                  <Link
                    href={item?.href}
                    className="text-[13px] text-[#64748B] hover:text-white transition-colors duration-200"
                  >
                    {item?.label}
                  </Link>
                </li>
              ))}
              <CookieSettingsButton />
            </ul>
          </div>
        </div>

        <div
          style={{ borderTop: '1px solid rgba(255,255,255,0.06)' }}
          className="py-8 text-center"
        >
          <p className="text-xs text-[#475569] mt-2">
            {new Date()?.getFullYear()} Incade. All rights reserved. Incade Is Powered By Eurekana &quot;Poland&quot;.
          </p>
        </div>
      </div>
    </footer>
  );
}
